import { mediaQuery } from 'constants/ui';

export const cardWrapperStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.secondary,
  padding: '20px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  height: '100%',

  [mediaQuery.mobile]: {
    padding: '16px',
    gap: '16px',
  },
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
};

export const iconWrapperStyles = ({ color, backgroundColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '44px',
  aspectRatio: 1,
  // Dark mode: the light pale fill would be a near-white blob, and the dark icon
  // would be illegible. Swap to a translucent accent fill + the pale color as the
  // (now bright) icon. Light mode keeps the original pale-fill/dark-icon pairing.
  backgroundColor: ({ palette }) => (palette.mode === 'dark' ? `${color}29` : backgroundColor),
  borderRadius: '100%',
  flexShrink: 0,

  '& > *': {
    color: ({ palette }) => (palette.mode === 'dark' ? backgroundColor : color),
    fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 0, 'opsz' 48",
  },

  [mediaQuery.mobile]: {
    height: '36px',
  },
});

export const headerTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  overflow: 'hidden',
  flex: 1,
};

export const dividerStyles = {
  borderColor: ({ palette }) => palette.border.default,
};

export const fieldsStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '16px',
};

export const fieldRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
};

export const fieldValueStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  textAlign: 'right',
};
